var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _vm._l(_vm.files, function(file) {
        return [
          _c(
            "v-col",
            {
              key: file.id + "_icon",
              staticClass:
                "text-center align-content-center fill-height align-content-center",
              attrs: { md: "1", cols: "1" }
            },
            [
              _c(
                "v-icon",
                {
                  staticStyle: {
                    "font-size": "46px",
                    color: "rgba(0, 0, 0, 0.32)",
                    position: "relative",
                    top: "10px"
                  }
                },
                [_vm._v("info")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { key: file.id + "_rest", attrs: { md: "3", cols: "11" } },
            [
              _c(
                "v-text-field",
                {
                  staticClass: "no-line-after-input",
                  attrs: {
                    label: _vm.$t("global.itemName"),
                    value: file.itemName,
                    readonly: "",
                    outlined: ""
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { position: "relative", top: "-7px" },
                      attrs: { slot: "append" },
                      slot: "append"
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$emit(
                                                "download",
                                                file.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("cloud_download")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ]
      }),
      _vm.files.length > 1
        ? [
            _c(
              "v-col",
              {
                staticClass:
                  "text-center align-content-center fill-height align-content-center",
                attrs: { md: "1", cols: "1" },
                on: { click: _vm.downloadAll }
              },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: {
                      "font-size": "46px",
                      color: "rgba(0, 0, 0, 0.32)",
                      position: "relative",
                      top: "10px"
                    }
                  },
                  [_vm._v("archive")]
                )
              ],
              1
            ),
            _c(
              "v-col",
              {
                attrs: { md: "3", cols: "11" },
                on: { click: _vm.downloadAll }
              },
              [
                _c(
                  "v-text-field",
                  {
                    staticClass: "no-line-after-input",
                    attrs: {
                      label: _vm.$t("global.downloadAll"),
                      readonly: "",
                      outlined: ""
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: { position: "relative", top: "-7px" },
                        attrs: { slot: "append" },
                        slot: "append"
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g({ attrs: { icon: "" } }, on),
                                        [
                                          _c("v-icon", [
                                            _vm._v("cloud_download")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3796452368
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }